import React from "react";

const PaginationControl = ({
  currentPage = 1,
  totalRecords = 0,
  pageSize = 10,
  onPrevious,
  onNext,
}) => {
  const totalPages = Math.ceil(totalRecords / pageSize) || 1;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        width: "100%",
        margin: "5px 0px",
      }}
    >
      <button
        onClick={onPrevious}
        disabled={currentPage <= 1}
        className="table-list-button"
      >
        <i className="fa-solid fa-chevron-left"></i>
      </button>
      <span className="table-list-page-txt">
        Page -{" "}
        <strong style={{ margin: "0px 3px" }}>
          {currentPage} of {totalPages}
        </strong>
      </span>
      <button
        onClick={onNext}
        disabled={currentPage >= totalPages}
        className="table-list-button"
      >
        <i className="fa-solid fa-chevron-right"></i>
      </button>
    </div>
  );
};

export default PaginationControl;
